export const verifyUserErrors = {
  noCompanyCode: 'Please use taxi company page to sign up/sign in',
};
export const userErrors = {
  emailExist: 'Email already exist',
  phoneExist: 'Phone number already exist',
  phoneNotFound: 'Phone number not found',
  emailNotFound: 'Email not found',
};
